export default () => ({
  postContainer: {
    transform: "scale(0.6) translateY(-25%)"
  },
  postPreviewContainer: {
    background: "#eaeaea",
    height: 300,
    overflowY: "scroll"
  }
});
